export const toCamelCase = function toCamelCase (string) {
    return string.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, char) => char.toUpperCase());
};

export const toSnakeCase = function toSnakeCase (string) {
    return string.replace(/[A-Z]/g, (c) => '_' + c.toLowerCase());
};
